<template>
  <div class="invite">
    <CommonDialog :show.sync="show" :dialog-title="title" top="calc(50vh - 172px)" :append-to-body="true" custom-class="share-dialog">
      <template v-slot:body>
        <div class="inviteDialog">
          <div class="content-dialog">
            <div class="txt">
              <div class="txt-content">
                {{ content }} <b>{{ url }}</b>
              </div>
            </div>
            <div
              id="copy"
              @click="handleCopy"
            >
              Copy
            </div>
            <div class="method-wrap">
              <a
                href="https://www.facebook.com"
                class="item facebook"
                @click="sentrySharePc('Facebook')"
              >
                <div class="icon " />
              </a>
              <a
                href="https://twitter.com"
                class="item twitter"
                @click="sentrySharePc('Twitter')"
              >
                <div class="icon " />
              </a>

              <a
                href="https://www.whatsapp.com"
                class="item whatsapp"
                @click="sentrySharePc('WhatsApp')"
              >
                <div class="icon " />
              </a>

              <a
                :href="
                  `mailto:?&subject=Email from Think Academy&body=${emailbody}`
                "
                class="item email"
                @click="sentrySharePc('Email')"
              >
                <div class="icon " />
              </a>
            </div>
          </div>
        </div>
      </template>
    </CommonDialog>
  </div>
</template>

<script>
import Clipboard from 'clipboard';
import CommonDialog from 'components/common/CommonDialog/index.vue';

export default {
  components: {
    CommonDialog,
  },
  props: {
    content: {
      default: '',
      type: String,
    },
    url: {
      default: '',
      type: String,
    },
    title: {
      default: '',
      type: String,
    },
    successMsg: {
      default: '',
      type: String,
    },
    activityId: {
      default: '',
      type: String,
    },
  },
  data() {
    return {
      show: false,

    }
  },
  computed: {
    userAgent() {
      return this.$store.state.userAgent;
    },
    emailbody() {
      return encodeURIComponent(`${this.content} ${this.url}`)
    },
  },
  watch: {

  },
  mounted() {
  },
  methods: {
    closeDialog() {
      this.show = false;
    },
    handleCopy() {
      const referClipboard = new Clipboard('#copy', {
        text: () => `${this.content} ${this.url}`,
      });

      referClipboard.on('success', () => {
        this.$ElMessage.closeAll()
        this.$ElMessage.success({ message: this.successMsg, offset: 200 });
      });

      referClipboard.on('error', () => {
        this.$ElMessage.closeAll()
        this.$ElMessage.error({ message: 'Copy failed', offset: 200 });
      });
    },

    async  openDialog() {
      this.show = true
    },

    sentrySharePc(data) {
      const that = this
      this.Sensors.track('group_invite_method_click', {
        invite_method: data,
        activity_id: that.activityId,
      });
    },
  },
}
</script>

<style lang="scss"  >
  .el-dialog.common-dialog {
    &.share-dialog {
      .el-dialog__body {
        .common-dialog-template {
          .dialog-header {
            margin: 0;
            border-radius: 16px 16px 0 0;
          }

          .dialog-body {
            background: #fff;
            border-radius: 0 0 16px 16px;
            padding: 0 0 16px;

            .inviteDialog .content-dialog {
              .txt {
                margin: 0 auto;
                padding: 12px 6px 12px 12px;
                margin-bottom: 20px;
                width: 468px;
                height: 115px;
                background: #f8f9fa;
                border-radius: 8px;
                font-size: 14px;
                font-weight: 500;
                color: var(--txt-color-lv2);
                line-height: 16px;
                overflow: hidden;

                .txt-content {
                  height: 100%;
                  overflow-y: scroll;
                  word-break: break-word;

                  b {
                    font-weight: initial;
                    text-decoration: underline;
                  }
                }
              }

              .method-wrap {
                padding: 30px  0 16px;
                text-align: center;

                .item {
                  display: inline-block;
                  margin-right: 50px;
                  width: 50px;
                  height: 50px;
                  border-radius: 10px;
                  position: relative;

                  &:nth-last-child(1) {
                    margin-right: 0;
                  }

                  &::before {
                    position: absolute;
                    content: '';
                    border-radius: 50%;
                    background: none;
                    left: 0;
                    display: block;
                    width: 50px;
                    height: 50px;
                  }

                  &.email {
                    background: url("~assets/images/share/icon_email_web.png") no-repeat;
                    background-size: 100%;
                  }

                  &.facebook {
                    background: url("~assets/images/share/icon_facebook_web.png") no-repeat;
                    background-size: 100%;
                  }

                  &.twitter {
                    background: url("~assets/images/share/icon_twitter_web.png") no-repeat;
                    background-size: 100%;
                  }

                  &.whatsapp {
                    background: url("~assets/images/share/icon_whatsapp_web.png") no-repeat;
                    background-size: 100%;
                  }

                  &:hover {
                    &::before {
                      background: rgba(0, 0, 0, 0.1);
                    }
                  }
                }
              }

              #copy {
                cursor: pointer;
                margin: 0 auto;
                width: 120px;
                height: 50px;
                display: flex;
                justify-content: space-around;
                align-items: center;
                background: var(--txt-color-link3);
                border-radius: 10px;
                font-size: 20px;
                font-weight: 600;
                color: var(--txt-color-link);
                line-height: 24px;
              }
            }
          }
        }
      }
    }
  }

</style>
